<template>
  <div>
    <h3>{{ panelTitle }}</h3>
    <section>
      <div class="form-inline">
        <label for="name">Name:</label>
        <div>
          <input name="name" id="name" type="text" placeholder="Name" v-model="editName" />
        </div>
      </div>
      <div class="form-inline">
        <label for="address">Address:</label>
        <div>
          <input
            name="address"
            id="address"
            type="text"
            placeholder="Address"
            v-model="editAddress"
          />
        </div>
      </div>
      <div class="form-inline">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
        >{{buttonLabel}}</spinnerButton>
      </div>
    </section>
  </div>
</template>

<script>
import "vue-search-select/dist/VueSearchSelect.css";
import { db } from "@/vendor/firebase";
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["type", "id", "name", "address", "submitLoading"],
  data() {
    return {
      panelTitle: "",
      buttonLabel: "",
      editName: "",
      editAddress: ""
    };
  },
  components: {
    spinnerButton
  },
  watch: {
    id: function(val) {
      this.initData();
    }
  },
  created: function() {
    this.initData();
  },
  methods: {
    initData: function() {
      if (this.type == "add") {
        this.panelTitle = "Add Location";
        this.buttonLabel = "Add Location";
        this.editName = "";
        this.editAddress = "";
      }
      if (this.type == "edit") {
        this.panelTitle = "Edit Location";
        this.buttonLabel = "Edit Location";
        this.editName = this.name;
        this.editAddress = this.address;
      }
    },
    buttonClick: function() {
      this.$emit(
        "locationButtonClick",
        this.id,
        this.editName,
        this.editAddress
      );
    }
  }
};
</script>